// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/chunk/" + chunkId + "-" + {"assets_src_js_external-links_js":"140206a933543502fc64","assets_src_js_nav_js":"558e4f7aa47a8fd1f703","assets_src_js_webform_js":"88c142706b76fede2bc0","assets_src_js_news-categories_js":"ea333ab0f6c5ac0127a8"}[chunkId] + ".js";
};